import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';
import { pathTypes } from '@utils/sectionEnums.js';

export function updateFormApiCall({
  id,
  isPathDesign,
  isCustomForm,

  isCustomFormName,
  isCustomFormEmail,
  isCustomFormPhone,
  isCustomFormAddress,
  isCustomFormComment,

  isCustomFormNameRequired,
  isCustomFormEmailRequired,
  isCustomFormPhoneRequired,
  isCustomFormAddressRequired,
  isCustomFormCommentRequired,

  customFormButtonTitle,
  customFormResultAction,
  customFormResultData,
  customFormViewType,
  customFormFields,

  customFormSuccessMessage,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  buttonOpacity,
  buttonBackgroundColor,
  buttonTextColor,
  buttonBorder,
  buttonBorderColor,
  buttonShadow,
  buttonShadowColor,
  buttonShape,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.form, isPathDesign), {
    id,
    isForm: isCustomForm,

    isFieldName: isCustomFormName,
    isFieldEmail: isCustomFormEmail,
    isFieldPhone: isCustomFormPhone,
    isFieldAddress: isCustomFormAddress,
    isFieldComment: isCustomFormComment,

    isFieldNameRequired: isCustomFormNameRequired,
    isFieldEmailRequired: isCustomFormEmailRequired,
    isFieldPhoneRequired: isCustomFormPhoneRequired,
    isFieldAddressRequired: isCustomFormAddressRequired,
    isFieldCommentRequired: isCustomFormCommentRequired,

    formResultAction: customFormResultAction,
    formResultData: customFormResultData,
    view: customFormViewType,
    formFields: customFormFields,
    formSuccessMessage: customFormSuccessMessage,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    buttonOpacity,
    buttonBackgroundColor,
    buttonTextColor,
    buttonBorder,
    buttonBorderColor,
    buttonShadow,
    buttonShadowColor,
    buttonShape,
  });
}
